import axios from "axios";

export default {
  events(query) {
    return axios.get("/api/events", {
      params: {
        per_page: query.perPage,
        page: query.page
      }
    });
  },
  eventsList(query) {
    return axios.get("/api/events_list", {
      params: {
        per_page: query.perPage,
        page: query.page
      }
    });
  },
  currentEvents() {
    return axios.get("/api/current_events");
  },
  listEvents() {
    return axios.get("/api/list_events");
  },
  event(id) {
    return axios.get("/api/event/show/" + id);
  },
  addEvent(data) {
    return axios
      .post("/api/event/add", data)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  editEvent(data) {
    return axios.post("/api/event/edit/" + data.id, data);
  },
  extendEventEnd(data) {
    return axios.post("/api/event/extend/" + data.id, data);
  },
  deleteEvent(data) {
    return axios.post("/api/event/delete", data);
  },

  eventCategories() {
    return axios.get("/api/event_categories");
  }
};
